<template>
   <div class="DeepDiveTab">
      <div class="container-fluid">
          <div class="row margin-Top-2Perc margin-bottom-2Perc margin-left-1Point7Perc margin-right-1Point3Perc grey-border">
              <div class="col-md-6 col-lg-6 font-size-18px padding-top-bottom-point-7Perc cursor-pointer text-align-center" v-bind:class="{'background-gray': isActive === 1 }" v-on:click="selectedDeepDiveReportTab($event,1)">
                Participants
              </div>
              <div class="left-border col-md-6 col-lg-6 font-size-18px padding-top-bottom-point-7Perc cursor-pointer text-align-center" v-bind:class="{'background-gray': isActive === 2}" v-on:click="selectedDeepDiveReportTab($event,2)">
                Views
              </div>   
          </div>      
      </div>
   </div>
</template>
   
<script>

export default {
  data: function () {
    return {
      isActive: 1
    }
  },
  components: {},
  methods: {
    selectedDeepDiveReportTab: function (event, flagToUpdate) {
      this.isActive = flagToUpdate
      this.$emit('clickedTab', parseInt(flagToUpdate))
    }
  },
  name: 'DeepDiveTab'
}
</script>
<style scoped>
.DeepDiveTab {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-right-1Point3Perc {
  margin-right: 1.3%;
}
.grey-border {
  border: 1px solid #aaa;
}
.font-size-18px {
  font-size: 18px;
}
.padding-top-bottom-point-7Perc {
  padding-top: 0.7% !important;
  padding-bottom: 0.7% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.margin-left-1Perc
{
  margin-left:1%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.margin-left-1Point7Perc
{
  margin-left:1.7%;
}
.text-align-center{
  text-align:center;
}
.left-border {
  border-left: 1px solid #aaa;
}
.background-gray {
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/DeepDiveTab.vue